<template>
  <div class="imgtextDetail">
    <div class="mainAll">
      <!-- <div style="height: 1.4rem;" v-if="urlKey"></div> -->
      <div class="info_title">
        {{ infoDetail.title }}
      </div>
      <div style="height: .8rem;"></div>

      <div class="info_userinfo">
        <div class="user_head">
          <img :src="infoDetail.user_info.avatar" />
        </div>
        <div class="user_name">
          {{ infoDetail.user_info.nickname }}
        </div>
        <div class="user_qianming">
          <span
            class="spanq1"
            @click="setQianshow"
            v-if="!infoDetail.user_info.personality && !urlKey"
          >
            点击设置个性签名</span
          >
          <span
            class="spanq2"
            @click="setQianshow"
            v-if="infoDetail.user_info.personality && !urlKey"
          >
            {{ infoDetail.user_info.personality }}</span
          >
          <span
            class="spanq3"
            v-if="infoDetail.user_info.personality && urlKey"
          >
            {{ infoDetail.user_info.personality }}</span
          >
        </div>
      </div>
      <div style="height: .3rem;"></div>
      <div v-if="advert.advert_type" style="width: 100%;">
        <router-link
          v-if="advert.advert_type == 'image'"
          :to="{
            path: '/shareActivity',
            query: { url: advert.details_image },
          }"
        >
          <img
            v-if="advert.advert_type == 'image'"
            style="width:100%;"
            :src="advert.advert_image"
          />
        </router-link>
        <router-link
          v-if="advert.advert_type == 'wechat_h5'"
          :to="{
            path: advert.h5_url,
          }"
        >
          <img style="width:100%;" :src="advert.advert_image" alt="" />
        </router-link>
        <div
          style="position: relative;"
          v-if="advert.advert_type == 'wechat_routine'"
        >
          <wx-open-launch-weapp
            style="position: absolute;top: 0;left: 0;bottom: 0;right: 0;z-index:1;overflow: hidden"
            :appid="advert.routine_appid"
            :path="advert.routine_url"
          >
            <script v-is="script" type="text/wxtag-template">
              <style v-is="style">
              <!-- .banner-img {
                    width: 100%;
                    height: 187.5px;
                  } -->
              </style>
              <div style="width:1000px;height:1000px;"></div>
            </script>
          </wx-open-launch-weapp>
          <img style="width:100%;" :src="advert.advert_image" />
        </div>
      </div>
      <div style="height: .3rem;"></div>
      <div class="main_info">
        <p>{{ infoDetail.head_info.ad_name }}</p>
        <img
          v-for="(item, index) in infoDetail.head_info.ad_image"
          :key="index"
          :src="item"
          style="display: block;width: 100%;"
        />
      </div>
      <div class="charu" v-if="!urlKey">
        <router-link
          :to="{
            path:
              '/jiaodian/insertion?attr=head&secret_key=' +
              infoDetail.secret_key +
              '&gg=' +
              JSON.stringify(infoDetail.head_info),
          }"
          >{{
            JSON.stringify(infoDetail.head_info).length > 2
              ? "修改我的广告"
              : "插入我的广告"
          }}</router-link
        >
      </div>
      <div
        class="audio"
        v-if="
          infoDetail.mediaid_url != null && infoDetail.mediaid_url.length != 0
        "
      >
        <div class="audio_title line1">
          {{ infoDetail.title }}
        </div>
        <div class="audio_box">
          <div class="audio_box_left">
            <div>{{ time(currentTime) }}</div>
            <!-- <van-progress
              :percentage="progress"
              color="#000"
              stroke-width="1px"
              track-color="rgba(0,0,0,.19)"
            /> -->
            <van-slider
              class="audio_progress"
              v-model="progress"
              button-size="6px"
              active-color="#000"
              inactive-color="rgba(0,0,0,.19)"
              @change="onChange"
            />
            <div>{{ time(duration) }}</div>
          </div>
          <div class="audio_box_right" @click.stop="audio_play">
            <img
              class="audio_btn"
              :src="
                !playing
                  ? require('../../../assets/images/audio_pause.png')
                  : require('../../../assets/images/audio_play.gif')
              "
              alt=""
            />
          </div>
        </div>
        <audio
          style="display:none;"
          :src="infoDetail.mediaid_url"
          controls
        ></audio>
        <audio
          controls
          @canplay="getDuration"
          @timeupdate="updateTime"
          ref="audio"
          loop="loop"
          style="display:none;"
        >
          <source
            :src="infoDetail.mediaid_url"
            ref="msource"
            type="audio/wav"
          />
          您的浏览器不支持音频播放
        </audio>
      </div>
      <div style="height: .2rem;"></div>
      <div class="main_info" v-html="infoDetail.content"></div>
      <div class="charu" v-if="!urlKey">
        <router-link
          :to="{
            path:
              '/jiaodian/insertion?attr=bottom&secret_key=' +
              infoDetail.secret_key +
              '&gg=' +
              JSON.stringify(infoDetail.bottom_info),
          }"
          >{{
            JSON.stringify(infoDetail.bottom_info).length > 2
              ? "修改我的广告"
              : "插入我的广告"
          }}</router-link
        >
      </div>
      <div class="main_info">
        <p>{{ infoDetail.bottom_info.ad_name }}</p>
        <img
          v-for="(item, index) in infoDetail.bottom_info.ad_image"
          :key="index"
          :src="item"
          style="display: block;width: 100%;"
        />
      </div>
      <div class="btns_footer">
        <div
          v-if="infoDetail.userCollect == false"
          @click="getArticleCollectAddNew('collect')"
        >
          <img
            src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_sc1.png"
          />收藏
        </div>
        <div
          v-if="infoDetail.userCollect"
          @click="getArticleCollectDelNew('collect')"
        >
          <img
            src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_sc2.png"
          />取消收藏
        </div>
        <div
          v-if="infoDetail.userLike == false"
          @click="getArticleCollectAddNew('like')"
        >
          <img
            src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_dz1.png"
          />好文章
        </div>
        <div
          v-if="infoDetail.userLike"
          @click="getArticleCollectDelNew('like')"
        >
          <img
            src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_dz2.png"
          />取消点赞
        </div>
        <!-- <div>
          <img
            src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_ts1.png"
          />投诉
        </div> -->
      </div>
      <div class="userinfo2">
        <div class="info_userinfo info_userinfo2" v-if="!urlKey">
          <div class="user_head">
            <img :src="infoDetail.user_info.avatar" />
          </div>
          <div class="user_name">{{ infoDetail.user_info.nickname }}</div>
          <p class="tags_bottom">
            <span v-for="(item, index) in infoDetail.cart_name" :key="index">{{
              item.cat_title
            }}</span>
          </p>
          <div class="user_btns">
            <div @click="addTel" v-if="!infoDetail.user_info.phone">
              加电话让客户联系你
            </div>
            <div
              @click="boTel(infoDetail.user_info.phone)"
              v-if="infoDetail.user_info.phone"
            >
              可拨打电话咨询
            </div>
            <div @click="tishoCXY" v-if="!infoDetail.user_info.wx_qr_code">
              加微信让客户联系你
            </div>
            <div @click="showEwm" v-if="infoDetail.user_info.wx_qr_code">
              查看二维码
            </div>
          </div>
        </div>
        <div class="userlist">
          <div class="userlistTitle">
            <span>热门资讯</span>
            <span
              ><router-link
                :to="{
                  path: '/jiaodian/userWeizhan?key=' + infoDetail.secret_key,
                }"
                >更多</router-link
              ></span
            >
          </div>
          <div class="newlist">
            <ul class="list1">
              <li
                v-for="(item, index) in articleList"
                :key="index"
                @click="gopageinfo(item.secret_key, item.id)"
              >
                <div class="li_l">
                  <div class="li_title">{{ item.title }}</div>
                </div>
                <div class="li_r">
                  <img :src="item.image_input[0]" class="li_img " />
                  <!-- <div>引流{{ item.visit ? item.visit : 0 }}次</div> -->
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--  <div class="zixunBtnUser" @click="zixunBtn" v-if="urlKey">
      <img
        src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/zixunico.png"
      />
    </div> -->
    <div class="editTextAll" @click="goEdit" v-if="!urlKey">
      编辑文章
    </div>
    <div class="footerBottom">
      <div class="indexBtn" @click="goindex">首页</div>
      <div class="shareBtn" v-if="!urlKey" @click="shareShowDialog">
        分享去引流
      </div>
      <div class="sharechangeBtn" @click="changemy" v-if="urlKey">
        变成我的文章
      </div>
    </div>

    <!-- 设置签名 -->
    <div class="setQianDialog dialog_MC" v-if="showQianDialog">
      <div class="setContent">
        <div class="setTitle">设置签名</div>
        <div class="setText">
          <textarea
            placeholder="设置签名,让别人了解你......"
            value="qianmingSign"
            v-model="qianmingSign"
            @input="qianmingInput($event.target.value)"
          ></textarea>
        </div>
        <div class="setbtns">
          <div class="setQuxiao" @click="setQianhide">取消</div>
          <div class="setYes" @click="saveQianSign">确定</div>
        </div>
      </div>
    </div>
    <!-- 未填写手机号，客户找不到你！ -->
    <div class="dialog_MC setPhoneDaialog" v-if="setphoneDialog">
      <div class="setContent">
        <div class="setTitle">未填写手机号，客户找不到你！</div>
        <div class="setText">
          <input
            class="inputphone"
            @input="AddPhone($event.target.value)"
            value="phone"
            v-model="phone"
            placeholder="输入手机号,让别人打给你"
          />
        </div>
        <div class="setbtns">
          <div class="setQuxiao" @click="setPhonehide">取消</div>
          <div class="setYes" @click="saveTel">确定</div>
        </div>
      </div>
    </div>
    <!-- 通过分享进入他人的页面，显示他人的咨询信息 -->
    <div class="dialog_MC zixunDialog" v-if="zixunDialog">
      <div class="setContent">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_close.png"
          class="close"
          @click="hideZixunDialog"
        />
        <div class="shareUserInfo">
          <div class="shareUhead">
            <img :src="infoDetail.user_info.avatar" />
          </div>
          <div class="shareUinfo">
            <div>{{ infoDetail.user_info.nickname }}</div>
            <div>{{ infoDetail.user_info.personality }}</div>
          </div>
        </div>
        <div class="shareBtninfo">
          <div v-if="!infoDetail.user_info.phone">未设置电话</div>
          <div
            v-if="infoDetail.user_info.phone"
            @click="boTel(infoDetail.user_info.phone)"
          >
            拨打电话咨询
          </div>
          <div v-if="!infoDetail.user_info.wx_qr_code">未设置微信</div>
          <div v-if="infoDetail.user_info.wx_qr_code" @click="showEwm">
            查看二维码
          </div>
        </div>
        <div class="beizhu">由娇娇颜究所所所所提供支持</div>
      </div>
    </div>
    <!-- 上传二维码客户咨询 -->
    <div class="dialog_MC erweimaDialog" v-if="erweimaDialog">
      <div class="erweima_c">
        <p>上传你的微信二维码图片<br />让客户主动加你</p>
        <div class="ewm_btn">
          <div class="ewmb1" @click="hideEwmDialog">取消</div>
          <div class="ewmb2">
            <input type="file" class="file" @change="upImg" ref="file" />去上传
          </div>
        </div>
      </div>
    </div>
    <!-- 二维码 -->
    <div
      class="dialog_MC ewmDialog"
      v-if="showEwmDialog"
      @click="hideEwmDialog1"
    >
      <div class="ewmDialog_1">
        <div class="zixunBox">
          <div class="zixunBox_1">
            <div class="userAvatar">
              <img :src="infoDetail.user_info.avatar" />
            </div>
            <div class="userInfoTop">
              <div class="userInfo_name">
                {{ infoDetail.user_info.nickname }}
              </div>
              <div class="userInfo_gongsi">
                {{ infoDetail.user_info.brand_title }}
              </div>
            </div>
          </div>
          <div class="userInfo_tel" @click="boTel(infoDetail.user_info.phone)">
            <img
              src="../../../assets/images/icophone2.png"
              style="width: .66rem;"
            />
          </div>
        </div>
        <p style="color: #999;padding: .8rem 0 .2rem;">
          加我微信，免费为您提供咨询服务
        </p>
        <img :src="infoDetail.user_info.wx_qr_code" />
        <p style="color: #999;">长按图片，识别图中二维码即可添加我为好友哦~</p>
      </div>
    </div>
    <!-- 分享提示 -->
    <div class="dialog_MC shareDialog" v-if="showShareDialog">
      <img
        src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/fenxiang.png"
      />
    </div>
    <!-- 2022.04.18更新新增顶部悬浮内容 -->
    <div class="newTopContent" v-if="urlKey && scrollTop">
      <div class="userAvatar">
        <img :src="infoDetail.user_info.avatar" />
      </div>
      <div class="userInfoTop">
        <div class="userInfo_name">{{ infoDetail.user_info.nickname }}</div>
        <div class="userInfo_gongsi">
          {{ infoDetail.user_info.brand_title }}
        </div>
      </div>
      <div class="userInfo_tel" @click="boTel(infoDetail.user_info.phone)">
        <img src="../../../assets/images/ico_phone.png" /><span>电话</span>
      </div>
      <div class="userInfo_weixin" @click="showEwm">
        <img src="../../../assets/images/ico_zixun.png" /><span>咨询</span>
      </div>
    </div>
  </div>
</template>

<script>
import "@assets/css/detail.css";
import "@assets/css/newlist2.css";
import { Toast, Progress, Slider } from "vant";
import {
  follow,
  getArticleDetailsNew,
  getPersonalitySigNew,
  postUserContact,
  getArticleCollectAddNew,
  getArticleCollectDelNew,
  getUploadImageNew,
  getUserInfo,
  postShareArticle,
} from "@api/public";
import { getArticleSystemAdvert } from "@/api/lcapi";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
// import { goShopDetail } from "@libs/order";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
// const MAPKEY = "mapKey";
let vm = null;
import wx from "weixin-js-sdk";
import { getWechatConfig } from "@api/public";

export default {
  name: "Index",
  components: {
    [Progress.name]: Progress,
    [Slider.name]: Slider,
  },
  props: {},
  data: function() {
    return {
      urlID: "",
      urlKey: "", //分享链接获取的key
      shareBtn: true,
      changeBtn: false,
      showQianDialog: false,
      setphoneDialog: false,
      zixunDialog: false,
      showShareDialog: false,
      erweimaDialog: false,
      showEwmDialog: false,
      bigewm: false,
      qianmingSign: "", //签名
      infoDetail: {},
      phone: "", //手机号
      articleList: [],
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: [],
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      mapKey: "",
      scrollTop: false,
      playing: false,
      duration: 0,
      currentTime: 0,
      progress: 0,
      advert: "",
    };
  },
  created() {
    vm = this;
  },
  computed: {
    time() {
      return function(time) {
        if (time == 0) {
          return "00:00";
        }
        let m = parseInt(time / 60);
        let s = time % 60;
        if (m < 10) {
          m = "0" + m;
        }
        if (s < 10) {
          s = "0" + s;
        }
        let Time = m + ":" + s;
        return Time;
      };
    },
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
  mounted: function() {
    this.urlID = this.$route.query.id;
    this.urlKey = this.$route.query.key;
    console.log("获取链接的this.urlKey：", this.urlKey);
    this.getFollow();
    this.getArticleDetailsNew();
    this.getUserInfo();
    window.addEventListener("scroll", this.handleScroll);
    this.getArticleSystemAdvert();
    getWechatConfig().then((data) => {
      console.log(data.data);
      wx.config({
        debug: false,
        appId: data.data.appId,
        timestamp: data.data.timestamp,
        nonceStr: data.data.nonceStr,
        signature: data.data.signature,
        jsApiList: [
          "checkJsApi",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "hideMenuItems",
          "showMenuItems",
          "hideAllNonBaseMenuItem",
          "showAllNonBaseMenuItem",
          "translateVoice",
          "startRecord",
          "stopRecord",
          "onRecordEnd",
          "playVoice",
          "pauseVoice",
          "stopVoice",
          "uploadVoice",
          "downloadVoice",
          "chooseImage",
          "previewImage",
          "uploadImage",
          "downloadImage",
          "getNetworkType",
          "openLocation",
          "getLocation",
          "hideOptionMenu",
          "showOptionMenu",
          "closeWindow",
          "scanQRCode",
          "chooseWXPay",
          "openProductSpecificView",
          "addCard",
          "chooseCard",
          "openCard",
        ],
        openTagList: ["wx-open-launch-weapp"],
      });
      wx.ready(function() {
        //config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      });
      wx.error(function() {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    });
  },
  methods: {
    getArticleSystemAdvert() {
      getArticleSystemAdvert().then((res) => {
        this.advert = res.data;
      });
    },
    /**
     * audio播放
     */
    audio_play() {
      if (this.playing) {
        this.$refs.audio.pause();
      } else {
        this.$refs.audio.play();
      }
      this.playing = !this.playing;
    },
    /**
     * 获取audio时长
     */
    getDuration() {
      console.log(parseInt(this.$refs.audio.duration));
      this.duration = parseInt(this.$refs.audio.duration);
    },
    /**
     * 获取audio当前播放位置
     */
    updateTime(e) {
      console.log(e.target.currentTime);
      this.currentTime = parseInt(e.target.currentTime);
      this.progress =
        (parseInt(e.target.currentTime) / parseInt(this.$refs.audio.duration)) *
        100;
    },
    /**
     * 拖到audio进度条
     */
    onChange(e) {
      let time = (e / 100) * this.duration;
      this.$refs.audio.currentTime = time;
      console.log(time);
    },
    getArticleDetailsNew() {
      var data;
      if (this.urlKey) {
        data = this.$route.query.id + "&key=" + this.urlKey;
      } else {
        data = this.$route.query.id;
      }
      getArticleDetailsNew(data).then((res) => {
        if (res.data.head_info.ad_image) {
          res.data.head_info.ad_image = res.data.head_info.ad_image.split(",");
        }
        if (res.data.bottom_info.ad_image) {
          res.data.bottom_info.ad_image = res.data.bottom_info.ad_image.split(
            ","
          );
        }

        res.data.content = res.data.content.replace(
          /<img/gi,
          '<img style="max-width:100%;height:auto;display:inline-block;margin:10px auto;"'
        );
        this.infoDetail = res.data;
        console.log("this.infoDetail：", this.infoDetail);
        this.setOpenShare();
      });
    },
    // 去编辑
    goEdit() {
      this.$router.push({
        path: "/jiaodian/editDetail?id=" + this.urlID,
      });
    },
    // 热门资讯
    getUserInfo() {
      var data = "?secret_key=" + this.urlKey + "&uid=";
      getUserInfo(data).then((res) => {
        this.articleList = res.data.article_list;
      });
    },

    shareShowDialog() {
      var that = this;
      that.showShareDialog = true;
      setTimeout(function() {
        that.showShareDialog = false;
        if (!that.infoDetail.user_info.phone) {
          that.setphoneDialog = true;
        }
      }, 1200);
    },
    tishoCXY() {
      this.erweimaDialog = true;
      // return this.$dialog.error("程序员开发中...");
    },
    goindex() {
      window.location.href = "/";
    },
    gopageinfo(secret_key, id) {
      // window.location.href =
      //   "/jiaodian/imgtextDetail?key=" + secret_key + "&id=" + id;
      // window.location.href = "/jiaodian/imgtextDetail?id=" + id;
      if (!this.urlKey) {
        window.location.href = "/jiaodian/imgtextDetail?id=" + id;
      } else {
        window.location.href =
          "/jiaodian/imgtextDetail?id=" + id + "&key=" + secret_key;
      }
    },
    // 显示签名
    setQianshow() {
      this.showQianDialog = true;
    },
    setQianhide() {
      this.showQianDialog = false;
    },
    setPhonehide() {
      this.setphoneDialog = false;
    },
    zixunBtn() {
      this.zixunDialog = true;
    },
    hideZixunDialog() {
      this.zixunDialog = false;
    },
    addTel() {
      this.setphoneDialog = true;
    },
    saveTel() {
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        return this.$dialog.error("请正确输入11位手机号！");
      } else {
        var data = {
          phone: this.phone,
          wx_qr_code: "",
        };
        console.log("1");
        postUserContact(data)
          .then((res) => {
            console.log("2");
            this.setphoneDialog = false;
            this.infoDetail.user_info.phone = this.phone;
            return this.$dialog.success(res.msg);
          })
          .catch((err) => {
            return Toast(err.msg);
          });
      }
    },
    boTel(e) {
      if (!e) {
        return this.$dialog.error("暂未提供手机号");
      } else {
        window.location.href = "tel://" + e;
      }
    },
    AddPhone(e) {
      this.phone = e;
    },
    qianmingInput(e) {
      this.qianmingSign = e;
    },
    saveQianSign() {
      var data = {
        personality: this.qianmingSign,
      };
      getPersonalitySigNew(data)
        .then((res) => {
          this.showQianDialog = false;
          this.infoDetail.user_info.personality = this.qianmingSign;
          return this.$dialog.success(res.msg);
        })
        .catch((err) => {
          return this.$dialog.error(err.msg);
        });
    },
    // 收藏or点赞
    getArticleCollectAddNew(type) {
      var that = this;
      var data = {
        id: that.urlID,
        type: type,
      };
      getArticleCollectAddNew(data)
        .then((res) => {
          if (type == "collect") {
            that.infoDetail.userCollect = true;
          } else {
            that.infoDetail.userLike = true;
          }
          return Toast(res.msg);
        })
        .catch((err) => {
          return Toast(err.msg);
        });
    },
    getArticleCollectDelNew(type) {
      var that = this;
      var data = {
        id: that.urlID,
        type: type,
      };
      getArticleCollectDelNew(data)
        .then((res) => {
          if (type == "collect") {
            that.infoDetail.userCollect = false;
          } else {
            that.infoDetail.userLike = false;
          }
          return Toast(res.msg);
        })
        .catch((err) => {
          return Toast(err.msg);
        });
    },
    upImg(e) {
      let that = this;
      var files = e.target.files[0];
      var formD1 = new FormData();
      formD1.append("file", e.target.files[0]);
      getUploadImageNew(formD1).then((res) => {
        var data = {
          phone: "",
          wx_qr_code: res.data.url,
        };
        postUserContact(data).then((res2) => {
          this.erweimaDialog = false;
          this.infoDetail.user_info.wx_qr_code = res.data.url;
          return Toast(res2.msg);
        });
      });
    },
    hideEwmDialog() {
      this.erweimaDialog = false;
    },
    showEwm() {
      if (!this.infoDetail.user_info.wx_qr_code) {
        return this.$dialog.error("暂未提供微信咨询方式");
      } else {
        this.showEwmDialog = true;
      }
    },
    hideEwmDialog1() {
      this.showEwmDialog = false;
    },
    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey)
          console.log("暂无法使用查看地图，请配置您的腾讯地图key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    changemy() {
      return this.$router.push({
        path: "/jiaodian/imgtextDetail?id=" + this.urlID,
      });
      // return window.open(location.href.split("?")[0] + "?id=" + this.urlID);
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    handleScroll() {
      // 元素到页面顶部的距离
      // var el_topHeight = this.$refs.one_video.offsetTop //注意：这边是指到有定位的父级的距离
      // 元素的高度
      // var el_Height = this.$refs.one_video.clientHeight
      // 可视区高度
      var clientHeight = document.documentElement.clientHeight;
      // 页面被卷去的高度
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (clientHeight + scrollTop > 120) {
        this.scrollTop = true;
      }
      if (scrollTop < 30) {
        this.scrollTop = false;
      }
    },
    getFollow() {
      follow()
        .then((res) => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    setOpenShare() {
      var that = this;
      if (isWeixin()) {
        console.log("111:", that.infoDetail.secret_key);
        console.log("that.urlKey:", that.urlKey);
        var urlKey;
        if (
          !that.urlKey ||
          that.urlKey == "" ||
          that.urlKey == undefined ||
          that.urlKey == "undefined"
        ) {
          urlKey = "&key=" + that.infoDetail.secret_key;
        } else {
          urlKey = "&key=" + that.urlKey;
        }
        var descText = that.infoDetail.synopsis ? that.infoDetail.synopsis : "";
        var configAppMessage = {
          desc: descText,
          title: that.infoDetail.title,
          link: location.href.split("?")[0] + "?id=" + that.urlID + urlKey,
          imgUrl: that.infoDetail.image_input[0],
        };
        openShareAll(configAppMessage);
        let data = { article_id: that.infoDetail.id };
        postShareArticle(data);
        // getShare().then(res => {
        //   var data = res.data.data;
        //   console.log("that.urlKey:", that.urlKey);
        //   var urlKey;
        //   if (
        //     !that.urlKey ||
        //     that.urlKey == "" ||
        //     that.urlKey == undefined ||
        //     that.urlKey == "undefined"
        //   ) {
        //     urlKey = "&key=" + that.infoDetail.secret_key;
        //   } else {
        //     urlKey = "&key=" + that.urlKey;
        //   }
        //   // var urlKey = that.urlKey
        //   //   ? "&key=" + that.urlKey
        //   //   : "&key=" + that.infoDetail.secret_key;
        //   var configAppMessage = {
        //     desc: data.synopsis,
        //     title: data.title,
        //     link: location.href.split("?")[0] + "?id=" + that.urlID + urlKey,
        //     imgUrl: data.img
        //   };
        //   openShareAll(configAppMessage);
        // });
      }
    },
  },
};
</script>

<style scoped>
/deep/ .van-slider__button {
  background: #000;
}
.tags_bottom {
  display: flex;
  justify-content: center;
  font-size: 0.22rem;
  width: 80%;
  margin: 0.2rem auto;
}
.tags_bottom span {
  margin: 0.1rem 0.2rem 0.1rem;
  color: #999;
}
.erweima_c {
  position: fixed;
  width: 5rem;
  background-color: #fff;
  border-radius: 0.2rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 0.3rem 0 0;
}
.erweima_c p {
  font-size: 0.28rem;
  text-align: center;
  line-height: 1.8;
  padding-bottom: 0.3rem;
}
.erweima_c .ewm_btn {
  border-top: 0.02rem solid #f0f0f0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  text-align: center;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
}
.erweima_c .ewm_btn > div {
  text-align: center;
}
.erweima_c .ewm_btn .ewmb1 {
  color: #999;
  width: 50%;
}
.erweima_c .ewm_btn .ewmb2 {
  color: #333;
  position: relative;
  width: 50%;
}
.erweima_c .ewm_btn .file {
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
}
.ewmDialog div.ewmDialog_1 {
  position: absolute;
  display: block;
  width: 6rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 0.2rem;
  text-align: center;
  border-radius: 0.15rem;
}
.zixunBox {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
}
.zixunBox_1 {
  width: 4rem;
  display: flex;
  align-items: center;
}
.zixunBox .userInfoTop {
  width: 3rem;
  justify-content: flex-start;
  text-align: left;
}
.ewmDialog img {
  display: block;
  width: 66%;
  margin: 0 auto 0.3rem;
}
.ewmDialog p {
  font-size: 0.24rem;
  text-align: center;
  width: 100%;
}
.newTopContent {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 0.1rem #f0f0f0;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.2rem;
}
.userAvatar {
  width: 0.8rem;
  height: 0.8rem;
  background-color: #f0f0f0;
  border-radius: 100%;
  overflow: hidden;
}
.userAvatar img {
  display: block;
  width: 100%;
}
.userInfoTop {
  width: 4rem;
  margin-left: 0.2rem;
  position: relative;
}
.userInfoTop .userInfo_name {
  font-size: 0.26rem;
  color: #000;
}
.userInfoTop .userInfo_gongsi {
  font-size: 0.24rem;
  color: #666;
  margin-top: 0.05rem;
}
.userInfo_tel,
.userInfo_weixin {
  width: 1rem;
}
.userInfo_tel img,
.userInfo_weixin img {
  display: block;
  width: 0.5rem;
  margin: 0 auto;
}
.userInfo_tel span,
.userInfo_weixin span {
  display: block;
  width: 100%;
  text-align: center;
  color: #999;
  font-size: 0.22rem;
}
.audio {
  min-height: 2rem;
  background: #f7f7f7;
  border-radius: 0.16rem;
  padding: 0.2rem;
}
.audio_title {
  font-size: 0.34rem;
  font-weight: bold;
  line-height: 1.2;
}
.audio_audio {
  margin: 0.4rem auto 0.2rem auto;
  display: none;
}
.audio_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.2rem;
}
.audio_box_left {
  flex: 1;
  padding: 0 0.2rem 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.audio_progress {
  flex: 1;
  margin: 0 0.08rem;
}
.audio_box_right {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background: #fff;
  font-size: 0;
}
.audio_btn {
  width: 0.8rem;
  height: 0.8rem;
}
.editTextAll {
  width: 1.6rem;
  height: 0.6rem;
  position: fixed;
  right: 0;
  bottom: 2.5rem;
  background: #ff410a;
  text-align: center;
  line-height: 0.6rem;
  color: #fff;
  border-radius: 0.1rem 0 0 0.1rem;
}
</style>

<!-- <style>
p,
span {
  white-space: pre-wrap !important;
}
</style> -->
